import { CLIENTES } from '../actions/types';

const initialState = {
    listado: [],
    listado_coincidencias: [],
    detalles: null, 
    ventana_filtros: false
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case CLIENTES.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case CLIENTES.BUSCAR_COINCIDENCIAS:
            return {
                ...state,
                listado_coincidencias: payload
            };

        case CLIENTES.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case CLIENTES.DETALLES:
            return {
                ...state,
                detalles: payload
            };
        
        default:
            return state;
    }
}